// import React, { useState, useEffect } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import '@fortawesome/fontawesome-free/css/all.min.css';

// const LauraDashboard = () => {
//   const [userData, setUserData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     // Client-side session check
//     if (!sessionStorage.getItem("loggedInUser")) {
//       window.location.href = "/login_receipt";
//       return;
//     }

//     fetchUserData();
//   }, []);

//   const fetchUserData = async () => {
//     try {
//       const token = sessionStorage.getItem("access_token");
//       const response = await fetch(`https://api.securxperts.com:8000/auth/me`, {
//         headers: {
//           "Authorization": `Bearer ${token}`,
//           "Content-Type": "application/json"
//         }
//       });
//       if (!response.ok) {
//         throw new Error('Failed to fetch user data');
//       }
//       const data = await response.json();
//       console.log("User Data:", data);
//       setUserData(data);
//     } catch (err) {
//       console.error("Error fetching data:", err);
//       setError('Error loading user data');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleLogout = () => {
//     sessionStorage.clear();
//     window.location.href = "/login_receipt";
//   };

//   if (loading) {
//     return (
//       <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
//         <div className="spinner-border text-light" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
//       {/* Navbar */}
//       <nav className="navbar navbar-expand-lg navbar-dark" style={{ background: 'rgba(0,0,0,0.2)' }}>
//         <div className="container">
//           <a className="navbar-brand fw-bold" href="/">
//             <i className="fas fa-shield-alt me-2"></i>
//             SecurXperts
//           </a>
//           <button className="btn btn-outline-light" onClick={handleLogout}>
//             <i className="fas fa-sign-out-alt me-2"></i>
//             Logout
//           </button>
//         </div>
//       </nav>

//       {/* Main Content */}
//       <div className="container py-5">
//         <div className="row justify-content-center">
//           <div className="col-lg-8">
//             {/* Welcome Card */}
//             <div className="card shadow-lg border-0 mb-4">
//               <div className="card-body p-5 text-center">
//                 <div className="mb-4">
//                   <i className="fas fa-user-circle fa-5x text-primary"></i>
//                 </div>
//                 <h2 className="card-title mb-3">
//                   Welcome to Your Dashboard
//                 </h2>
//                 {error ? (
//                   <div className="alert alert-warning">
//                     <i className="fas fa-exclamation-triangle me-2"></i>
//                     {error}
//                   </div>
//                 ) : userData ? (
//                   <div>
//                     <p className="lead text-muted mb-4">
//                       You are logged in as: <strong>{userData.email || sessionStorage.getItem("email")}</strong>
//                     </p>
//                     <div className="row g-3 mt-4">
//                       <div className="col-md-6">
//                         <div className="card bg-primary text-white h-100">
//                           <div className="card-body text-center">
//                             <i className="fas fa-envelope fa-2x mb-2"></i>
//                             <h6>Email</h6>
//                             <p className="mb-0 small">{userData.email || 'N/A'}</p>
//                           </div>
//                         </div>
//                       </div>
//                       <div className="col-md-6">
//                         <div className="card bg-success text-white h-100">
//                           <div className="card-body text-center">
//                             <i className="fas fa-check-circle fa-2x mb-2"></i>
//                             <h6>Status</h6>
//                             <p className="mb-0 small">Active</p>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 ) : (
//                   <p className="text-muted">
//                     Logged in as: <strong>{sessionStorage.getItem("email")}</strong>
//                   </p>
//                 )}
//               </div>
//             </div>

//             {/* Quick Actions */}
//             <div className="card shadow border-0">
//               <div className="card-header bg-white border-0 pt-4">
//                 <h5 className="mb-0">
//                   <i className="fas fa-bolt me-2 text-warning"></i>
//                   Quick Actions
//                 </h5>
//               </div>
//               <div className="card-body">
//                 <div className="row g-3">
//                   <div className="col-md-4">
//                     <a href="/" className="btn btn-outline-primary w-100 py-3">
//                       <i className="fas fa-home d-block mb-2 fa-lg"></i>
//                       Home
//                     </a>
//                   </div>
//                   <div className="col-md-4">
//                     <a href="/our-services" className="btn btn-outline-success w-100 py-3">
//                       <i className="fas fa-concierge-bell d-block mb-2 fa-lg"></i>
//                       Services
//                     </a>
//                   </div>
//                   <div className="col-md-4">
//                     <a href="/contact-us" className="btn btn-outline-info w-100 py-3">
//                       <i className="fas fa-envelope d-block mb-2 fa-lg"></i>
//                       Contact
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LauraDashboard;



import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';

const DevOpsInquiries = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeSection, setActiveSection] = useState('overview'); // Track active section
  const [quotations, setQuotations] = useState([]); // For quotations data
  const [quotationsLoading, setQuotationsLoading] = useState(false);
  const [quotationsError, setQuotationsError] = useState(null);
  const [lauratekB2B, setLauratekB2B] = useState([]); // For lauratek-b2b data
  const [lauratekB2BLoading, setLauratekB2BLoading] = useState(false);
  const [lauratekB2BError, setLauratekB2BError] = useState(null);
  const [lauratekB2C, setLauratekB2C] = useState([]); // For lauratek-b2c data
  const [lauratekB2CLoading, setLauratekB2CLoading] = useState(false);
  const [lauratekB2CError, setLauratekB2CError] = useState(null);
  const [hrms, setHrms] = useState([]); // For hrms data
  const [hrmsLoading, setHrmsLoading] = useState(false);
  const [hrmsError, setHrmsError] = useState(null);
  const [onestepmedi, setOnestepmedi] = useState([]); // For onestepmedi data
  const [onestepmediLoading, setOnestepmediLoading] = useState(false);
  const [onestepmediError, setOnestepmediError] = useState(null);
  const [careers, setCareers] = useState([]); // For career data
  const [careersLoading, setCareersLoading] = useState(false);
  const [careersError, setCareersError] = useState(null);
  const [hms, setHms] = useState([]); // For hms data
  const [hmsLoading, setHmsLoading] = useState(false);
  const [hmsError, setHmsError] = useState(null);
  const [lensLight, setLensLight] = useState([]); // For lens-light data
  const [lensLightLoading, setLensLightLoading] = useState(false);
  const [lensLightError, setLensLightError] = useState(null);
  const [sams, setSams] = useState([]); // For sams data
  const [samsLoading, setSamsLoading] = useState(false);
  const [samsError, setSamsError] = useState(null);
  const [contacts, setContacts] = useState([]); // For contact data
  const [contactsLoading, setContactsLoading] = useState(false);
  const [contactsError, setContactsError] = useState(null);
  const [services, setServices] = useState([]); // For services data
  const [servicesLoading, setServicesLoading] = useState(false);
  const [servicesError, setServicesError] = useState(null);

  useEffect(() => {
    // Client-side session check
    const isLoggedIn = sessionStorage.getItem("loggedInUser") || sessionStorage.getItem("loggedin");
    if (!isLoggedIn) {
      navigate("/login_receipt");
      return;
    }

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  const fetchData = async () => {
    try {
      // Get access token from session storage
      const accessToken = sessionStorage.getItem("access_token");
      const tokenType = sessionStorage.getItem("token_type") || "bearer";

      if (!accessToken) {
        setError("You must be logged in to view data.");
        setLoading(false);
        navigate("/login_receipt");
        return;
      }

      // Build headers with authentication (Bearer token required for GET endpoints)
      const headers = {
        'Accept': 'application/json',
        'Authorization': `Bearer ${accessToken}` // Ensure Bearer format (capital B)
      };

      // Try different possible endpoints based on Swagger docs
      // GET endpoints require authentication and may return different formats
      // Note: GET endpoints return plain string "string" per Swagger schema
      const possibleEndpoints = [
        'https://api.securxperts.com:8000/forms/services', // Get all services inquiries
        'https://api.securxperts.com:8000/forms/contact', // Get contact inquiries
        'https://api.securxperts.com:8000/forms/quotation', // Get quotations
      ];

      let fetchedData = null;
      let lastError = null;

      // Try each endpoint until one works
      for (const apiUrl of possibleEndpoints) {
        try {
          console.log('📤 Trying endpoint:', apiUrl);
          
          const response = await fetch(apiUrl, {
            method: 'GET',
            headers: headers
          });

          console.log('📥 Response status:', response.status, response.statusText);

          if (response.status === 404) {
            console.log(`⚠️ Endpoint ${apiUrl} returned 404, trying next...`);
            continue; // Try next endpoint
          }

      if (!response.ok) {
            // Handle specific error codes according to API schema
            if (response.status === 401) {
              const errorData = await response.json().catch(() => ({ detail: 'Not authenticated' }));
              throw new Error(`Authentication failed: ${errorData.detail || 'Not authenticated'}. Please log in again.`);
            }
            if (response.status === 403) {
              throw new Error('Access forbidden. You do not have permission to access this resource.');
            }
            if (response.status === 404) {
              console.log(`⚠️ Endpoint ${apiUrl} returned 404, trying next...`);
              continue; // Try next endpoint
            }
            // Try to get error details from response
            let errorMessage = `Server returned ${response.status}: ${response.statusText}`;
            try {
              const errorData = await response.json();
              if (errorData.detail) {
                errorMessage = Array.isArray(errorData.detail) 
                  ? errorData.detail.map(e => e.msg || e).join(', ')
                  : errorData.detail;
              } else if (errorData.message) {
                errorMessage = errorData.message;
              }
            } catch {
              // If JSON parsing fails, use default message
            }
            throw new Error(errorMessage);
          }

          // Check content type and handle response accordingly
          const contentType = response.headers.get("content-type") || '';
          
          let parsedData;
          if (contentType.includes("application/json")) {
            parsedData = await response.json();
          } else {
            // Handle non-JSON responses (e.g., plain text/string)
            const text = await response.text();
            console.warn('⚠️ Received non-JSON response:', text.substring(0, 200));
            // Try to parse as JSON if it looks like JSON
            try {
              parsedData = JSON.parse(text);
            } catch {
              // If it's a plain string, wrap it or handle accordingly
              parsedData = text ? { message: text } : null;
            }
          }

          fetchedData = parsedData;
          console.log("✅ Successfully fetched data from:", apiUrl);
          console.log("📥 Response status:", response.status);
          console.log("📥 Fetched Data:", fetchedData);
          break; // Success, exit loop
        } catch (err) {
          console.error(`❌ Error with endpoint ${apiUrl}:`, err.message);
          lastError = err;
          continue; // Try next endpoint
        }
      }

      // If all endpoints failed
      if (!fetchedData) {
        setError(
          'DevOps inquiries endpoint not available. ' +
          'The API endpoint for retrieving DevOps inquiries may not be implemented yet. ' +
          'Please check Swagger docs at https://api.securxperts.com:8000/docs or contact the administrator.'
        );
        setLoading(false);
        return;
      }

      // Handle different response formats according to API schema
      // GET /forms/contact and GET /forms/services may return:
      // - Array directly: [...]
      // - Object with data: { data: [...] }
      // - Object with items: { items: [...] }
      // - String (as per Swagger docs showing "string" response)
      let dataArray = [];
      
      if (Array.isArray(fetchedData)) {
        // Direct array response
        dataArray = fetchedData;
      } else if (fetchedData && typeof fetchedData === 'object') {
        // Object response - check for common properties
        if (Array.isArray(fetchedData.data)) {
          dataArray = fetchedData.data;
        } else if (Array.isArray(fetchedData.items)) {
          dataArray = fetchedData.items;
        } else if (Array.isArray(fetchedData.results)) {
          dataArray = fetchedData.results;
        } else if (Array.isArray(fetchedData.contacts)) {
          dataArray = fetchedData.contacts;
        } else if (Array.isArray(fetchedData.services)) {
          dataArray = fetchedData.services;
        } else {
          // If it's an object but not an array, log for debugging
          console.warn('⚠️ Response is an object but no array found. Structure:', Object.keys(fetchedData));
          // Try to extract any array values
          const values = Object.values(fetchedData);
          const foundArray = values.find(v => Array.isArray(v));
          if (foundArray) {
            dataArray = foundArray;
          } else {
            dataArray = [];
          }
        }
      } else if (typeof fetchedData === 'string') {
        // String response (as per Swagger schema showing "string" type for GET endpoints)
        console.warn('⚠️ GET /forms/services returned string response:', fetchedData);
        // If it's a JSON string, try to parse it
        try {
          const parsed = JSON.parse(fetchedData);
          if (Array.isArray(parsed)) {
            dataArray = parsed;
          } else if (parsed && typeof parsed === 'object') {
            // If parsed object has array properties, extract them
            const values = Object.values(parsed);
            const foundArray = values.find(v => Array.isArray(v));
            if (foundArray) {
              dataArray = foundArray;
            } else {
              dataArray = [];
            }
          } else {
            dataArray = [];
          }
        } catch {
          // Not JSON - plain string response (as per Swagger schema)
          // This might indicate the endpoint is not fully implemented or returns a message
          console.warn('⚠️ Plain string response received (not JSON). This may indicate the endpoint returns a message rather than data.');
          dataArray = [];
        }
      } else {
        console.warn('⚠️ Unexpected response format:', typeof fetchedData, fetchedData);
        dataArray = [];
      }

      // Filter for DevOps-related inquiries if we got all services
      // This is a fallback if there's no specific DevOps endpoint
      if (dataArray.length > 0) {
        const devopsData = dataArray.filter(item => {
          // Filter by course/service type if available
          const course = item.course?.toLowerCase() || item.service?.toLowerCase() || item.type_of_service?.toLowerCase() || '';
          const name = item.name?.toLowerCase() || '';
          return course.includes('devops') || name.includes('devops') || 
                 course.includes('docker') || course.includes('kubernetes') ||
                 course.includes('aws') || course.includes('azure') ||
                 course.includes('ci/cd') || course.includes('jenkins');
        });
        
        if (devopsData.length > 0) {
          setData(devopsData);
        } else if (dataArray.length > 0) {
          // If no DevOps-specific data found, show all data
          console.log('⚠️ No DevOps-specific data found, showing all inquiries');
          setData(dataArray);
        } else {
          setData([]);
        }
      } else {
        setData([]);
      }
    } catch (err) {
      console.error("❌ Error fetching data:", err);
      setError(err.message || 'Error loading data. Please check your connection and try again.');
    } finally {
      setLoading(false);
    }
  };

  // Fetch quotations data
  const fetchQuotations = async () => {
    try {
      setQuotationsLoading(true);
      setQuotationsError(null);

      const accessToken = sessionStorage.getItem("access_token");
      if (!accessToken) {
        setQuotationsError("You must be logged in to view quotations.");
        setQuotationsLoading(false);
        return;
      }

      const headers = {
        'Accept': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      };

      const response = await fetch('https://api.securxperts.com:8000/forms/quotation', {
        method: 'GET',
        headers: headers
      });

      console.log('📥 Quotations response status:', response.status, response.statusText);

      if (response.status === 401) {
        throw new Error('Authentication failed. Please log in again.');
      }

      if (!response.ok) {
        let errorMessage = `Server returned ${response.status}: ${response.statusText}`;
        try {
          const errorData = await response.json();
          if (errorData.detail) {
            errorMessage = Array.isArray(errorData.detail) 
              ? errorData.detail.map(e => e.msg || e).join(', ')
              : errorData.detail;
          }
        } catch {
          // If JSON parsing fails, use default message
        }
        throw new Error(errorMessage);
      }

      // Handle response - API may return string, array, or object
      const contentType = response.headers.get("content-type") || '';
      let parsedData;
      
      if (contentType.includes("application/json")) {
        parsedData = await response.json();
      } else {
        const text = await response.text();
        try {
          parsedData = JSON.parse(text);
        } catch {
          // If it's a plain string (as per Swagger schema showing "string")
          console.warn('⚠️ GET /forms/quotation returned plain string:', text);
          parsedData = text ? { message: text } : null;
        }
      }

      // Handle different response formats
      let dataArray = [];
      if (Array.isArray(parsedData)) {
        dataArray = parsedData;
      } else if (parsedData && typeof parsedData === 'object') {
        if (Array.isArray(parsedData.data)) {
          dataArray = parsedData.data;
        } else if (Array.isArray(parsedData.items)) {
          dataArray = parsedData.items;
        } else if (Array.isArray(parsedData.results)) {
          dataArray = parsedData.results;
        } else if (Array.isArray(parsedData.quotations)) {
          dataArray = parsedData.quotations;
        } else {
          // If it's an object but not an array, try to extract any array values
          const values = Object.values(parsedData);
          const foundArray = values.find(v => Array.isArray(v));
          if (foundArray) {
            dataArray = foundArray;
          }
        }
      }

      setQuotations(dataArray);
      console.log("✅ Successfully fetched quotations:", dataArray.length, "items");
    } catch (err) {
      console.error("❌ Error fetching quotations:", err);
      setQuotationsError(err.message || 'Error loading quotations. Please check your connection and try again.');
    } finally {
      setQuotationsLoading(false);
    }
  };

  // Fetch quotations when section is active
  useEffect(() => {
    if (activeSection === 'quotations') {
      fetchQuotations();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSection]);

  // Fetch lauratek-b2b data
  const fetchLauratekB2B = async () => {
    try {
      setLauratekB2BLoading(true);
      setLauratekB2BError(null);

      const accessToken = sessionStorage.getItem("access_token");
      if (!accessToken) {
        setLauratekB2BError("You must be logged in to view B2B inquiries.");
        setLauratekB2BLoading(false);
        return;
      }

      const headers = {
        'Accept': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      };

      const response = await fetch('https://api.securxperts.com:8000/forms/lauratek-b2b', {
        method: 'GET',
        headers: headers
      });

      console.log('📥 Lauratek B2B response status:', response.status, response.statusText);

      if (response.status === 401) {
        throw new Error('Authentication failed. Please log in again.');
      }

      if (!response.ok) {
        let errorMessage = `Server returned ${response.status}: ${response.statusText}`;
        try {
          const errorData = await response.json();
          if (errorData.detail) {
            errorMessage = Array.isArray(errorData.detail) 
              ? errorData.detail.map(e => e.msg || e).join(', ')
              : errorData.detail;
          }
        } catch {
          // If JSON parsing fails, use default message
        }
        throw new Error(errorMessage);
      }

      // Handle response - API may return string, array, or object
      const contentType = response.headers.get("content-type") || '';
      let parsedData;
      
      if (contentType.includes("application/json")) {
        parsedData = await response.json();
      } else {
        const text = await response.text();
        try {
          parsedData = JSON.parse(text);
        } catch {
          // If it's a plain string (as per Swagger schema showing "string")
          console.warn('⚠️ GET /forms/lauratek-b2b returned plain string:', text);
          parsedData = text ? { message: text } : null;
        }
      }

      // Handle different response formats
      let dataArray = [];
      if (Array.isArray(parsedData)) {
        dataArray = parsedData;
      } else if (parsedData && typeof parsedData === 'object') {
        if (Array.isArray(parsedData.data)) {
          dataArray = parsedData.data;
        } else if (Array.isArray(parsedData.items)) {
          dataArray = parsedData.items;
        } else if (Array.isArray(parsedData.results)) {
          dataArray = parsedData.results;
        } else if (Array.isArray(parsedData.b2b)) {
          dataArray = parsedData.b2b;
        } else {
          // If it's an object but not an array, try to extract any array values
          const values = Object.values(parsedData);
          const foundArray = values.find(v => Array.isArray(v));
          if (foundArray) {
            dataArray = foundArray;
          }
        }
      }

      setLauratekB2B(dataArray);
      console.log("Successfully fetched lauratek-b2b:", dataArray.length, "items");
    } catch (err) {
      console.error("Error fetching lauratek-b2b:", err);
      setLauratekB2BError(err.message || 'Error loading B2B inquiries. Please check your connection and try again.');
    } finally {
      setLauratekB2BLoading(false);
    }
  };

  // Fetch lauratek-b2c data
  const fetchLauratekB2C = async () => {
    try {
      setLauratekB2CLoading(true);
      setLauratekB2CError(null);

      const accessToken = sessionStorage.getItem("access_token");
      if (!accessToken) {
        setLauratekB2CError("You must be logged in to view B2C inquiries.");
        setLauratekB2CLoading(false);
        return;
      }

      const headers = {
        'Accept': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      };

      const response = await fetch('https://api.securxperts.com:8000/forms/lauratek-b2c', {
        method: 'GET',
        headers: headers
      });

      console.log('Lauratek B2C response status:', response.status, response.statusText);

      if (response.status === 401) {
        throw new Error('Authentication failed. Please log in again.');
      }

      if (!response.ok) {
        let errorMessage = `Server returned ${response.status}: ${response.statusText}`;
        try {
          const errorData = await response.json();
          if (errorData.detail) {
            errorMessage = Array.isArray(errorData.detail) 
              ? errorData.detail.map(e => e.msg || e).join(', ')
              : errorData.detail;
          }
        } catch {
          // If JSON parsing fails, use default message
        }
        throw new Error(errorMessage);
      }

      // Handle response - API may return string, array, or object
      const contentType = response.headers.get("content-type") || '';
      let parsedData;
      
      if (contentType.includes("application/json")) {
        parsedData = await response.json();
      } else {
        const text = await response.text();
        try {
          parsedData = JSON.parse(text);
        } catch {
          // If it's a plain string (as per Swagger schema showing "string")
          console.warn('GET /forms/lauratek-b2c returned plain string:', text);
          parsedData = text ? { message: text } : null;
        }
      }

      // Handle different response formats
      let dataArray = [];
      if (Array.isArray(parsedData)) {
        dataArray = parsedData;
      } else if (parsedData && typeof parsedData === 'object') {
        if (Array.isArray(parsedData.data)) {
          dataArray = parsedData.data;
        } else if (Array.isArray(parsedData.items)) {
          dataArray = parsedData.items;
        } else if (Array.isArray(parsedData.results)) {
          dataArray = parsedData.results;
        } else if (Array.isArray(parsedData.b2c)) {
          dataArray = parsedData.b2c;
        } else {
          // If it's an object but not an array, try to extract any array values
          const values = Object.values(parsedData);
          const foundArray = values.find(v => Array.isArray(v));
          if (foundArray) {
            dataArray = foundArray;
          }
        }
      }

      setLauratekB2C(dataArray);
      console.log("Successfully fetched lauratek-b2c:", dataArray.length, "items");
    } catch (err) {
      console.error("Error fetching lauratek-b2c:", err);
      setLauratekB2CError(err.message || 'Error loading B2C inquiries. Please check your connection and try again.');
    } finally {
      setLauratekB2CLoading(false);
    }
  };

  // Fetch lauratek-b2b when section is active
  useEffect(() => {
    if (activeSection === 'lauratek-b2b') {
      fetchLauratekB2B();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSection]);

  // Fetch lauratek-b2c when section is active
  useEffect(() => {
    if (activeSection === 'lauratek-b2c') {
      fetchLauratekB2C();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSection]);

  // Fetch hrms data
  const fetchHrms = async () => {
    try {
      setHrmsLoading(true);
      setHrmsError(null);

      const accessToken = sessionStorage.getItem("access_token");
      if (!accessToken) {
        setHrmsError("You must be logged in to view HRMS inquiries.");
        setHrmsLoading(false);
        return;
      }

      const headers = {
        'Accept': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      };

      const response = await fetch('https://api.securxperts.com:8000/forms/hrms', {
        method: 'GET',
        headers: headers
      });

      console.log('📥 HRMS response status:', response.status, response.statusText);

      if (response.status === 401) {
        throw new Error('Authentication failed. Please log in again.');
      }

      if (!response.ok) {
        let errorMessage = `Server returned ${response.status}: ${response.statusText}`;
        try {
          const errorData = await response.json();
          if (errorData.detail) {
            errorMessage = Array.isArray(errorData.detail) 
              ? errorData.detail.map(e => e.msg || e).join(', ')
              : errorData.detail;
          }
        } catch {
          // If JSON parsing fails, use default message
        }
        throw new Error(errorMessage);
      }

      // Handle response - API may return string, array, or object
      const contentType = response.headers.get("content-type") || '';
      let parsedData;
      
      if (contentType.includes("application/json")) {
        parsedData = await response.json();
      } else {
        const text = await response.text();
        try {
          parsedData = JSON.parse(text);
        } catch {
          // If it's a plain string (as per Swagger schema showing "string")
          console.warn('⚠️ GET /forms/hrms returned plain string:', text);
          parsedData = text ? { message: text } : null;
        }
      }

      // Handle different response formats
      let dataArray = [];
      if (Array.isArray(parsedData)) {
        dataArray = parsedData;
      } else if (parsedData && typeof parsedData === 'object') {
        if (Array.isArray(parsedData.data)) {
          dataArray = parsedData.data;
        } else if (Array.isArray(parsedData.items)) {
          dataArray = parsedData.items;
        } else if (Array.isArray(parsedData.results)) {
          dataArray = parsedData.results;
        } else if (Array.isArray(parsedData.hrms)) {
          dataArray = parsedData.hrms;
        } else {
          // If it's an object but not an array, try to extract any array values
          const values = Object.values(parsedData);
          const foundArray = values.find(v => Array.isArray(v));
          if (foundArray) {
            dataArray = foundArray;
          }
        }
      }

      setHrms(dataArray);
      console.log("✅ Successfully fetched hrms:", dataArray.length, "items");
    } catch (err) {
      console.error("❌ Error fetching hrms:", err);
      setHrmsError(err.message || 'Error loading HRMS inquiries. Please check your connection and try again.');
    } finally {
      setHrmsLoading(false);
    }
  };

  // Fetch hrms when section is active
  useEffect(() => {
    if (activeSection === 'hrms') {
      fetchHrms();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSection]);

  // Fetch onestepmedi data
  const fetchOnestepmedi = async () => {
    try {
      setOnestepmediLoading(true);
      setOnestepmediError(null);

      const accessToken = sessionStorage.getItem("access_token");
      if (!accessToken) {
        setOnestepmediError("You must be logged in to view Onestepmedi inquiries.");
        setOnestepmediLoading(false);
        return;
      }

      const headers = {
        'Accept': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      };

      const response = await fetch('https://api.securxperts.com:8000/forms/onestepmedi', {
        method: 'GET',
        headers: headers
      });

      console.log('📥 Onestepmedi response status:', response.status, response.statusText);

      if (response.status === 401) {
        throw new Error('Authentication failed. Please log in again.');
      }

      if (!response.ok) {
        let errorMessage = `Server returned ${response.status}: ${response.statusText}`;
        try {
          const errorData = await response.json();
          if (errorData.detail) {
            errorMessage = Array.isArray(errorData.detail) 
              ? errorData.detail.map(e => e.msg || e).join(', ')
              : errorData.detail;
          }
        } catch {
          // If JSON parsing fails, use default message
        }
        throw new Error(errorMessage);
      }

      // Handle response - API may return string, array, or object
      const contentType = response.headers.get("content-type") || '';
      let parsedData;
      
      if (contentType.includes("application/json")) {
        parsedData = await response.json();
      } else {
        const text = await response.text();
        try {
          parsedData = JSON.parse(text);
        } catch {
          // If it's a plain string (as per Swagger schema showing "string")
          console.warn('⚠️ GET /forms/onestepmedi returned plain string:', text);
          parsedData = text ? { message: text } : null;
        }
      }

      // Handle different response formats
      let dataArray = [];
      if (Array.isArray(parsedData)) {
        dataArray = parsedData;
      } else if (parsedData && typeof parsedData === 'object') {
        if (Array.isArray(parsedData.data)) {
          dataArray = parsedData.data;
        } else if (Array.isArray(parsedData.items)) {
          dataArray = parsedData.items;
        } else if (Array.isArray(parsedData.results)) {
          dataArray = parsedData.results;
        } else if (Array.isArray(parsedData.onestepmedi)) {
          dataArray = parsedData.onestepmedi;
        } else {
          // If it's an object but not an array, try to extract any array values
          const values = Object.values(parsedData);
          const foundArray = values.find(v => Array.isArray(v));
          if (foundArray) {
            dataArray = foundArray;
          }
        }
      }

      setOnestepmedi(dataArray);
      console.log("✅ Successfully fetched onestepmedi:", dataArray.length, "items");
    } catch (err) {
      console.error("❌ Error fetching onestepmedi:", err);
      setOnestepmediError(err.message || 'Error loading Onestepmedi inquiries. Please check your connection and try again.');
    } finally {
      setOnestepmediLoading(false);
    }
  };

  // Fetch onestepmedi when section is active
  useEffect(() => {
    if (activeSection === 'onestepmedi') {
      fetchOnestepmedi();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSection]);

  // Fetch careers data
  const fetchCareers = async () => {
    try {
      setCareersLoading(true);
      setCareersError(null);

      const accessToken = sessionStorage.getItem("access_token");
      if (!accessToken) {
        setCareersError("You must be logged in to view career applications.");
        setCareersLoading(false);
        return;
      }

      const headers = {
        'Accept': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      };

      const response = await fetch('https://api.securxperts.com:8000/forms/career', {
        method: 'GET',
        headers: headers
      });

      console.log('📥 Careers response status:', response.status, response.statusText);

      if (response.status === 401) {
        throw new Error('Authentication failed. Please log in again.');
      }

      if (!response.ok) {
        let errorMessage = `Server returned ${response.status}: ${response.statusText}`;
        try {
          const errorData = await response.json();
          if (errorData.detail) {
            errorMessage = Array.isArray(errorData.detail) 
              ? errorData.detail.map(e => e.msg || e).join(', ')
              : errorData.detail;
          }
        } catch {
          // If JSON parsing fails, use default message
        }
        throw new Error(errorMessage);
      }

      // Handle response - API may return string, array, or object
      const contentType = response.headers.get("content-type") || '';
      let parsedData;
      
      if (contentType.includes("application/json")) {
        parsedData = await response.json();
      } else {
        const text = await response.text();
        try {
          parsedData = JSON.parse(text);
        } catch {
          // If it's a plain string (as per Swagger schema showing "string")
          console.warn('⚠️ GET /forms/career returned plain string:', text);
          parsedData = text ? { message: text } : null;
        }
      }

      // Handle different response formats
      let dataArray = [];
      if (Array.isArray(parsedData)) {
        dataArray = parsedData;
      } else if (parsedData && typeof parsedData === 'object') {
        if (Array.isArray(parsedData.data)) {
          dataArray = parsedData.data;
        } else if (Array.isArray(parsedData.items)) {
          dataArray = parsedData.items;
        } else if (Array.isArray(parsedData.results)) {
          dataArray = parsedData.results;
        } else if (Array.isArray(parsedData.careers)) {
          dataArray = parsedData.careers;
        } else {
          // If it's an object but not an array, try to extract any array values
          const values = Object.values(parsedData);
          const foundArray = values.find(v => Array.isArray(v));
          if (foundArray) {
            dataArray = foundArray;
          }
        }
      }

      setCareers(dataArray);
      console.log("✅ Successfully fetched careers:", dataArray.length, "items");
    } catch (err) {
      console.error("❌ Error fetching careers:", err);
      setCareersError(err.message || 'Error loading career applications. Please check your connection and try again.');
    } finally {
      setCareersLoading(false);
    }
  };

  // Fetch careers when section is active
  useEffect(() => {
    if (activeSection === 'careers') {
      fetchCareers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSection]);

  // Fetch hms data
  const fetchHms = async () => {
    try {
      setHmsLoading(true);
      setHmsError(null);

      const accessToken = sessionStorage.getItem("access_token");
      if (!accessToken) {
        setHmsError("You must be logged in to view HMS inquiries.");
        setHmsLoading(false);
        return;
      }

      const headers = {
        'Accept': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      };

      const response = await fetch('https://api.securxperts.com:8000/forms/hms', {
        method: 'GET',
        headers: headers
      });

      console.log('📥 HMS response status:', response.status, response.statusText);

      if (response.status === 401) {
        throw new Error('Authentication failed. Please log in again.');
      }

      if (!response.ok) {
        let errorMessage = `Server returned ${response.status}: ${response.statusText}`;
        try {
          const errorData = await response.json();
          if (errorData.detail) {
            errorMessage = Array.isArray(errorData.detail) 
              ? errorData.detail.map(e => e.msg || e).join(', ')
              : errorData.detail;
          }
        } catch {
          // If JSON parsing fails, use default message
        }
        throw new Error(errorMessage);
      }

      // Handle response - API may return string, array, or object
      const contentType = response.headers.get("content-type") || '';
      let parsedData;
      
      if (contentType.includes("application/json")) {
        parsedData = await response.json();
      } else {
        const text = await response.text();
        try {
          parsedData = JSON.parse(text);
        } catch {
          // If it's a plain string (as per Swagger schema showing "string")
          console.warn('⚠️ GET /forms/hms returned plain string:', text);
          parsedData = text ? { message: text } : null;
        }
      }

      // Handle different response formats
      let dataArray = [];
      if (Array.isArray(parsedData)) {
        dataArray = parsedData;
      } else if (parsedData && typeof parsedData === 'object') {
        if (Array.isArray(parsedData.data)) {
          dataArray = parsedData.data;
        } else if (Array.isArray(parsedData.items)) {
          dataArray = parsedData.items;
        } else if (Array.isArray(parsedData.results)) {
          dataArray = parsedData.results;
        } else if (Array.isArray(parsedData.hms)) {
          dataArray = parsedData.hms;
        } else {
          // If it's an object but not an array, try to extract any array values
          const values = Object.values(parsedData);
          const foundArray = values.find(v => Array.isArray(v));
          if (foundArray) {
            dataArray = foundArray;
          }
        }
      }

      setHms(dataArray);
      console.log("✅ Successfully fetched hms:", dataArray.length, "items");
    } catch (err) {
      console.error("❌ Error fetching hms:", err);
      setHmsError(err.message || 'Error loading HMS inquiries. Please check your connection and try again.');
    } finally {
      setHmsLoading(false);
    }
  };

  // Fetch hms when section is active
  useEffect(() => {
    if (activeSection === 'hms') {
      fetchHms();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSection]);

  // Fetch sams data
  const fetchSams = async () => {
    try {
      setSamsLoading(true);
      setSamsError(null);

      const accessToken = sessionStorage.getItem("access_token");
      if (!accessToken) {
        setSamsError("You must be logged in to view SAMS inquiries.");
        setSamsLoading(false);
        return;
      }

      const headers = {
        'Accept': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      };

      const response = await fetch('https://api.securxperts.com:8000/forms/sams', {
        method: 'GET',
        headers: headers
      });

      console.log('📥 SAMS response status:', response.status, response.statusText);

      if (response.status === 401) {
        throw new Error('Authentication failed. Please log in again.');
      }

      if (!response.ok) {
        let errorMessage = `Server returned ${response.status}: ${response.statusText}`;
        try {
          const errorData = await response.json();
          if (errorData.detail) {
            errorMessage = Array.isArray(errorData.detail) 
              ? errorData.detail.map(e => e.msg || e).join(', ')
              : errorData.detail;
          }
        } catch {
          // If JSON parsing fails, use default message
        }
        throw new Error(errorMessage);
      }

      // Handle response - API may return string, array, or object
      const contentType = response.headers.get("content-type") || '';
      let parsedData;
      
      if (contentType.includes("application/json")) {
        parsedData = await response.json();
      } else {
        const text = await response.text();
        try {
          parsedData = JSON.parse(text);
        } catch {
          // If it's a plain string (as per Swagger schema showing "string")
          console.warn('⚠️ GET /forms/sams returned plain string:', text);
          parsedData = text ? { message: text } : null;
        }
      }

      // Handle different response formats
      let dataArray = [];
      if (Array.isArray(parsedData)) {
        dataArray = parsedData;
      } else if (parsedData && typeof parsedData === 'object') {
        if (Array.isArray(parsedData.data)) {
          dataArray = parsedData.data;
        } else if (Array.isArray(parsedData.items)) {
          dataArray = parsedData.items;
        } else if (Array.isArray(parsedData.results)) {
          dataArray = parsedData.results;
        } else if (Array.isArray(parsedData.sams)) {
          dataArray = parsedData.sams;
        } else {
          // If it's an object but not an array, try to extract any array values
          const values = Object.values(parsedData);
          const foundArray = values.find(v => Array.isArray(v));
          if (foundArray) {
            dataArray = foundArray;
          }
        }
      }

      setSams(dataArray);
      console.log("✅ Successfully fetched sams:", dataArray.length, "items");
    } catch (err) {
      console.error("❌ Error fetching sams:", err);
      setSamsError(err.message || 'Error loading SAMS inquiries. Please check your connection and try again.');
    } finally {
      setSamsLoading(false);
    }
  };

  // Fetch sams when section is active
  useEffect(() => {
    if (activeSection === 'sams') {
      fetchSams();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSection]);

  // Fetch contacts data
  const fetchContacts = async () => {
    try {
      setContactsLoading(true);
      setContactsError(null);

      const accessToken = sessionStorage.getItem("access_token");
      if (!accessToken) {
        setContactsError("You must be logged in to view contact inquiries.");
        setContactsLoading(false);
        return;
      }

      const headers = {
        'Accept': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      };

      const response = await fetch('https://api.securxperts.com:8000/forms/contact', {
        method: 'GET',
        headers: headers
      });

      console.log('📥 Contacts response status:', response.status, response.statusText);

      if (response.status === 401) {
        throw new Error('Authentication failed. Please log in again.');
      }

      if (!response.ok) {
        let errorMessage = `Server returned ${response.status}: ${response.statusText}`;
        try {
          const errorData = await response.json();
          if (errorData.detail) {
            errorMessage = Array.isArray(errorData.detail) 
              ? errorData.detail.map(e => e.msg || e).join(', ')
              : errorData.detail;
          }
        } catch {
          // If JSON parsing fails, use default message
        }
        throw new Error(errorMessage);
      }

      // Handle response - API may return string, array, or object
      const contentType = response.headers.get("content-type") || '';
      let parsedData;
      
      if (contentType.includes("application/json")) {
        parsedData = await response.json();
      } else {
        const text = await response.text();
        try {
          parsedData = JSON.parse(text);
        } catch {
          // If it's a plain string (as per Swagger schema showing "string")
          console.warn('⚠️ GET /forms/contact returned plain string:', text);
          parsedData = text ? { message: text } : null;
        }
      }

      // Handle different response formats
      let dataArray = [];
      if (Array.isArray(parsedData)) {
        dataArray = parsedData;
      } else if (parsedData && typeof parsedData === 'object') {
        if (Array.isArray(parsedData.data)) {
          dataArray = parsedData.data;
        } else if (Array.isArray(parsedData.items)) {
          dataArray = parsedData.items;
        } else if (Array.isArray(parsedData.results)) {
          dataArray = parsedData.results;
        } else if (Array.isArray(parsedData.contacts)) {
          dataArray = parsedData.contacts;
        } else {
          // If it's an object but not an array, try to extract any array values
          const values = Object.values(parsedData);
          const foundArray = values.find(v => Array.isArray(v));
          if (foundArray) {
            dataArray = foundArray;
          }
        }
      }

      setContacts(dataArray);
      console.log("✅ Successfully fetched contacts:", dataArray.length, "items");
    } catch (err) {
      console.error("❌ Error fetching contacts:", err);
      setContactsError(err.message || 'Error loading contact inquiries. Please check your connection and try again.');
    } finally {
      setContactsLoading(false);
    }
  };

  // Fetch contacts when section is active
  useEffect(() => {
    if (activeSection === 'contacts') {
      fetchContacts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSection]);

  // Fetch services data
  const fetchServices = async () => {
    try {
      setServicesLoading(true);
      setServicesError(null);

      const accessToken = sessionStorage.getItem("access_token");
      if (!accessToken) {
        setServicesError("You must be logged in to view service inquiries.");
        setServicesLoading(false);
        return;
      }

      const headers = {
        'Accept': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      };

      const response = await fetch('https://api.securxperts.com:8000/forms/services', {
        method: 'GET',
        headers: headers
      });

      console.log('📥 Services response status:', response.status, response.statusText);

      if (response.status === 401) {
        throw new Error('Authentication failed. Please log in again.');
      }

      if (!response.ok) {
        let errorMessage = `Server returned ${response.status}: ${response.statusText}`;
        try {
          const errorData = await response.json();
          if (errorData.detail) {
            errorMessage = Array.isArray(errorData.detail) 
              ? errorData.detail.map(e => e.msg || e).join(', ')
              : errorData.detail;
          }
        } catch {
          // If JSON parsing fails, use default message
        }
        throw new Error(errorMessage);
      }

      // Handle response - API may return string, array, or object
      const contentType = response.headers.get("content-type") || '';
      let parsedData;
      
      if (contentType.includes("application/json")) {
        parsedData = await response.json();
      } else {
        const text = await response.text();
        try {
          parsedData = JSON.parse(text);
        } catch {
          // If it's a plain string (as per Swagger schema showing "string")
          console.warn('⚠️ GET /forms/services returned plain string:', text);
          parsedData = text ? { message: text } : null;
        }
      }

      // Handle different response formats
      let dataArray = [];
      if (Array.isArray(parsedData)) {
        dataArray = parsedData;
      } else if (parsedData && typeof parsedData === 'object') {
        if (Array.isArray(parsedData.data)) {
          dataArray = parsedData.data;
        } else if (Array.isArray(parsedData.items)) {
          dataArray = parsedData.items;
        } else if (Array.isArray(parsedData.results)) {
          dataArray = parsedData.results;
        } else if (Array.isArray(parsedData.services)) {
          dataArray = parsedData.services;
        } else {
          // If it's an object but not an array, try to extract any array values
          const values = Object.values(parsedData);
          const foundArray = values.find(v => Array.isArray(v));
          if (foundArray) {
            dataArray = foundArray;
          }
        }
      }

      setServices(dataArray);
      console.log("✅ Successfully fetched Services:", dataArray.length, "items");
    } catch (err) {
      console.error("❌ Error fetching services:", err);
      setServicesError(err.message || 'Error loading service inquiries. Please check your connection and try again.');
    } finally {
      setServicesLoading(false);
    }
  };

  // Fetch services when section is active
  useEffect(() => {
    if (activeSection === 'services') {
      fetchServices();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSection]);

  // Fetch lens-light data
  const fetchLensLight = async () => {
    try {
      setLensLightLoading(true);
      setLensLightError(null);

      const accessToken = sessionStorage.getItem("access_token");
      if (!accessToken) {
        setLensLightError("You must be logged in to view Lens & Light inquiries.");
        setLensLightLoading(false);
        return;
      }

      const headers = {
        'Accept': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      };

      const response = await fetch('https://api.securxperts.com:8000/forms/contact-llmedia', {
        method: 'GET',
        headers: headers
      });

      console.log('📥 Lens & Light response status:', response.status, response.statusText);

      if (response.status === 401) {
        throw new Error('Authentication failed. Please log in again.');
      }

      if (!response.ok) {
        let errorMessage = `Server returned ${response.status}: ${response.statusText}`;
        try {
          const errorData = await response.json();
          if (errorData.detail) {
            errorMessage = Array.isArray(errorData.detail) 
              ? errorData.detail.map(e => e.msg || e).join(', ')
              : errorData.detail;
          }
        } catch {
          // If JSON parsing fails, use default message
        }
        throw new Error(errorMessage);
      }

      // Handle response - API may return string, array, or object
      const contentType = response.headers.get("content-type") || '';
      let parsedData;
      
      if (contentType.includes("application/json")) {
        parsedData = await response.json();
      } else {
        const text = await response.text();
        try {
          parsedData = JSON.parse(text);
        } catch {
          // If it's a plain string (as per Swagger schema showing "string")
          console.warn('⚠️ GET /forms/contact-llmedia returned plain string:', text);
          parsedData = text ? { message: text } : null;
        }
      }

      // Handle different response formats
      let dataArray = [];
      if (Array.isArray(parsedData)) {
        dataArray = parsedData;
      } else if (parsedData && typeof parsedData === 'object') {
        if (Array.isArray(parsedData.data)) {
          dataArray = parsedData.data;
        } else if (Array.isArray(parsedData.items)) {
          dataArray = parsedData.items;
        } else if (Array.isArray(parsedData.results)) {
          dataArray = parsedData.results;
        } else if (Array.isArray(parsedData.lensLight)) {
          dataArray = parsedData.lensLight;
        } else {
          // If it's an object but not an array, try to extract any array values
          const values = Object.values(parsedData);
          const foundArray = values.find(v => Array.isArray(v));
          if (foundArray) {
            dataArray = foundArray;
          }
        }
      }

      setLensLight(dataArray);
      console.log("✅ Successfully fetched Lens & Light inquiries:", dataArray.length, "items");
    } catch (err) {
      console.error("❌ Error fetching Lens & Light inquiries:", err);
      setLensLightError(err.message || 'Error loading Lens & Light inquiries. Please check your connection and try again.');
    } finally {
      setLensLightLoading(false);
    }
  };

  // Fetch lens-light when section is active
  useEffect(() => {
    if (activeSection === 'lens-light') {
      fetchLensLight();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSection]);

  if (loading) {
    return (
      <div className="container mt-4">
        <div className="text-center">Loading...</div>
      </div>
    );
  }

  const handleLogout = () => {
    sessionStorage.removeItem("loggedInUser");
    sessionStorage.removeItem("access_token");
    sessionStorage.removeItem("token_type");
    sessionStorage.removeItem("email");
    navigate("/login_receipt");
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <style>{`
        body {
          background-color: #f8f9fa;
          font-family: 'Poppins', sans-serif;
        }
        .dashboard-header {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          padding: 20px 30px;
          margin-bottom: 30px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }
        .dashboard-sidebar {
          background: white;
          min-height: calc(100vh - 100px);
          padding: 20px;
          box-shadow: 2px 0 10px rgba(0,0,0,0.05);
        }
        .nav-item-custom {
          margin-bottom: 10px;
        }
        .nav-link-custom {
          display: flex;
          align-items: center;
          padding: 12px 20px;
          color: #495057;
          text-decoration: none;
          border-radius: 8px;
          transition: all 0.3s;
          cursor: pointer;
        }
        .nav-link-custom:hover {
          background-color: #e9ecef;
          color: #667eea;
        }
        .nav-link-custom.active {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
        }
        .nav-link-custom i {
          margin-right: 10px;
          width: 20px;
        }
        .dashboard-content {
          background: white;
          padding: 30px;
          border-radius: 8px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.05);
        }
        .stats-card {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          padding: 20px;
          border-radius: 8px;
          margin-bottom: 20px;
        }
        .stats-card h3 {
          margin: 0;
          font-size: 2.5rem;
        }
        .stats-card p {
          margin: 5px 0 0 0;
          opacity: 0.9;
        }
      `}</style>
      
      {/* Dashboard Header */}
      <div className="dashboard-header">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h2 style={{ margin: 0, fontWeight: 'bold' }}>
              <i className="fas fa-tachometer-alt me-2"></i>
              Dashboard
            </h2>
            <p style={{ margin: '5px 0 0 0', opacity: 0.9 }}>
              Welcome back! Manage your inquiries and receipts.
            </p>
          </div>
          <button 
            className="btn btn-light" 
            onClick={handleLogout}
            style={{ borderRadius: '20px' }}
          >
            <i className="fas fa-sign-out-alt me-2"></i>Logout
          </button>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row">
          {/* Sidebar Navigation */}
          <div className="col-md-3">
            <div className="dashboard-sidebar">
              <nav className="nav flex-column">
                <div className="nav-item-custom">
                  <div 
                    className={`nav-link-custom ${activeSection === 'overview' ? 'active' : ''}`}
                    onClick={() => setActiveSection('overview')}
                  >
                    <i className="fas fa-home"></i>
                    Overview
                  </div>
                </div>
                <div className="nav-item-custom">
                  <div 
                    className={`nav-link-custom ${activeSection === 'services' ? 'active' : ''}`}
                    onClick={() => setActiveSection('services')}
                  >
                    <i className="fas fa-cogs"></i>
                    Service Inquiries
                  </div>
                </div>
                <div className="nav-item-custom">
                  <div 
                    className={`nav-link-custom ${activeSection === 'contacts' ? 'active' : ''}`}
                    onClick={() => setActiveSection('contacts')}
                  >
                    <i className="fas fa-envelope"></i>
                    Contact Inquiries
                  </div>
                </div>
                <div className="nav-item-custom">
                  <div 
                    className={`nav-link-custom ${activeSection === 'quotations' ? 'active' : ''}`}
                    onClick={() => setActiveSection('quotations')}
                  >
                    <i className="fas fa-file-invoice-dollar"></i>
                    Quotations
                  </div>
                </div>
                <div className="nav-item-custom">
                  <div 
                    className={`nav-link-custom ${activeSection === 'lauratek-b2b' ? 'active' : ''}`}
                    onClick={() => setActiveSection('lauratek-b2b')}
                  >
                    <i className="fas fa-building"></i>
                    Lauratek B2B
                  </div>
                </div>
                <div className="nav-item-custom">
                  <div 
                    className={`nav-link-custom ${activeSection === 'lauratek-b2c' ? 'active' : ''}`}
                    onClick={() => setActiveSection('lauratek-b2c')}
                  >
                    <i className="fas fa-user-graduate"></i>
                    Lauratek B2C
                  </div>
                </div>
                <div className="nav-item-custom">
                  <div 
                    className={`nav-link-custom ${activeSection === 'hrms' ? 'active' : ''}`}
                    onClick={() => setActiveSection('hrms')}
                  >
                    <i className="fas fa-users"></i>
                    HRMS Inquiries
                  </div>
                </div>
                <div className="nav-item-custom">
                  <div 
                    className={`nav-link-custom ${activeSection === 'lens-light' ? 'active' : ''}`}
                    onClick={() => setActiveSection('lens-light')}
                  >
                    <i className="fas fa-camera"></i>
                    Lens & Light media Inquiries
                  </div>
                </div>
                {/* <div className="nav-item-custom">
                  <div 
                    className={`nav-link-custom ${activeSection === 'custom-table' ? 'active' : ''}`}
                    onClick={() => setActiveSection('custom-table')}
                  >
                    <i className="fas fa-table"></i>
                    Custom Table
                  </div>
                </div> */}
                <div className="nav-item-custom">
                  <div 
                    className={`nav-link-custom ${activeSection === 'hms' ? 'active' : ''}`}
                    onClick={() => setActiveSection('hms')}
                  >
                    <i className="fas fa-hospital"></i>
                    HMS Inquiries
                  </div>
                </div>
                <div className="nav-item-custom">
                  <div 
                    className={`nav-link-custom ${activeSection === 'sams' ? 'active' : ''}`}
                    onClick={() => setActiveSection('sams')}
                  >
                    <i className="fas fa-school"></i>
                    SAMS Inquiries
                  </div>
                </div>
                <div className="nav-item-custom">
                  <div 
                    className={`nav-link-custom ${activeSection === 'onestepmedi' ? 'active' : ''}`}
                    onClick={() => setActiveSection('onestepmedi')}
                  >
                    <i className="fas fa-heartbeat"></i>
                    Onestepmedi Inquiries
                  </div>
                </div>
                
                <div className="nav-item-custom">
                  <div 
                    className={`nav-link-custom ${activeSection === 'careers' ? 'active' : ''}`}
                    onClick={() => setActiveSection('careers')}
                  >
                    <i className="fas fa-briefcase"></i>
                    Career Applications
                  </div>
                </div>
                <div className="nav-item-custom">
                  <div 
                    className="nav-link-custom"
                    onClick={() => navigate('/getstudent')}
                  >
                    <i className="fas fa-graduation-cap"></i>
                    Student Receipts
                  </div>
                </div>
                <div className="nav-item-custom">
                  <div 
                    className="nav-link-custom"
                    onClick={() => navigate('/Receipt')}
                  >
                    <i className="fas fa-file-invoice"></i>
                    Generate Receipt
                  </div>
                </div>
              </nav>
            </div>
          </div>

          {/* Main Content Area */}
          <div className="col-md-9">
            <div className="dashboard-content">
              {activeSection === 'overview' && (
                <div>
                  <h3 className="mb-4">Dashboard Overview</h3>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="stats-card" style={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' }}>
                        <h3>-</h3>
                        <p><i className="fas fa-graduation-cap me-2"></i>Total Students</p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="stats-card" style={{ background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)' }}>
                        <h3>-</h3>
                        <p><i className="fas fa-file-invoice me-2"></i>Total Receipts</p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4">
                    <h5>Quick Actions</h5>
                    <div className="d-flex gap-3 mt-3">
                      <button 
                        className="btn btn-success"
                        onClick={() => navigate('/studentdashboard')}
                      >
                        <i className="fas fa-graduation-cap me-2"></i>View Student Receipts
                      </button>
                      <button 
                        className="btn btn-info"
                        onClick={() => navigate('/Receipt')}
                      >
                        <i className="fas fa-file-invoice me-2"></i>Generate Receipt
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {activeSection === 'services' && (
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3>Service Inquiries</h3>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={fetchServices}
                      disabled={servicesLoading}
                    >
                      <i className="fas fa-sync-alt me-2"></i>
                      {servicesLoading ? 'Refreshing...' : 'Refresh'}
                    </button>
                  </div>

                  {servicesLoading ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-3">Loading service inquiries...</p>
                    </div>
                  ) : servicesError ? (
                    <div className="alert alert-danger">
                      <i className="fas fa-exclamation-triangle me-2"></i>
                      {servicesError}
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped table-hover">
                        <thead className="table-dark">
                          <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Service</th>
                            <th>Industry</th>
                            <th>Location</th>
                            <th>Availability</th>
                            {/* <th>Submitted At</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {services.length === 0 ? (
                            <tr>
                              <td colSpan="9" className="text-center text-muted py-4">
                                <i className="fas fa-inbox fa-2x mb-2" style={{ opacity: 0.3 }}></i>
                                <p className="mb-0">No service inquiries found</p>
                              </td>
                            </tr>
                          ) : (
                            services.map((item, index) => (
                              <tr key={item.id || index}>
                                <td>{item.id || index + 1}</td>
                                <td>{item.name || 'N/A'}</td>
                                <td>{item.email || 'N/A'}</td>
                                <td>{item.phoneno || item.phone || item.phone_number || 'N/A'}</td>
                                <td>{item.service || item.type_of_service || item.course || 'N/A'}</td>
                                <td>{item.company || item.industry_type || 'N/A'}</td>
                                <td>{item.location || item.city || 'N/A'}</td>
                                <td>{item.location || item.availability || 'N/A'}</td>
                                {/* <td>{item.message ? (item.message.length > 50 ? item.message.substring(0, 50) + '...' : item.message) : 'N/A'}</td> */}
                                {/* <td>{item.submitted_at || item.date || item.created_at || 'N/A'}</td> */}
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}

              {activeSection === 'contacts' && (
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3>Contact Inquiries</h3>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={fetchContacts}
                      disabled={contactsLoading}
                    >
                      <i className="fas fa-sync-alt me-2"></i>
                      {contactsLoading ? 'Refreshing...' : 'Refresh'}
                    </button>
                  </div>

                  {contactsLoading ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-3">Loading contact inquiries...</p>
                    </div>
                  ) : contactsError ? (
                    <div className="alert alert-danger">
                      <i className="fas fa-exclamation-triangle me-2"></i>
                      {contactsError}
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped table-hover">
                        <thead className="table-dark">
                          <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Location</th>
                            <th>purpose</th>
                            <th>Message</th>
                            {/* <th>Submitted At</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {contacts.length === 0 ? (
                            <tr>
                              <td colSpan="7" className="text-center text-muted py-4">
                                <i className="fas fa-inbox fa-2x mb-2" style={{ opacity: 0.3 }}></i>
                                <p className="mb-0">No contact inquiries found</p>
                              </td>
                            </tr>
                          ) : (
                            contacts.map((item, index) => (
                              <tr key={item.id || index}>
                                <td>{item.id || index + 1}</td>
                                <td>{item.name || 'N/A'}</td>
                                <td>{item.email || 'N/A'}</td>
                                <td>{item.phoneno || item.phone || item.phone_number || 'N/A'}</td>
                                <td>{item.location || 'N/A'}</td>
                                 <td>{item.purpose || 'N/A'}</td>
                                <td>{item.message ? (item.message.length > 50 ? item.message.substring(0, 50) + '...' : item.message) : 'N/A'}</td>
                                {/* <td>{item.submitted_at || item.date || item.created_at || 'N/A'}</td> */}
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}

              {activeSection === 'quotations' && (
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3>Quotations</h3>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={fetchQuotations}
                      disabled={quotationsLoading}
                    >
                      <i className="fas fa-sync-alt me-2"></i>
                      {quotationsLoading ? 'Refreshing...' : 'Refresh'}
                    </button>
                  </div>

                  {quotationsLoading ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-3">Loading quotations...</p>
                    </div>
                  ) : quotationsError ? (
                    <div className="alert alert-danger">
                      <i className="fas fa-exclamation-triangle me-2"></i>
                      {quotationsError}
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped table-hover">
                        <thead className="table-dark">
                          <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Company</th>
                            <th>Service</th>
                            {/* <th>Subject</th> */}
                            <th>Message</th>
                            {/* <th>Submitted At</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {quotations.length === 0 ? (
                            <tr>
                              <td colSpan="9" className="text-center text-muted py-4">
                                <i className="fas fa-inbox fa-2x mb-2" style={{ opacity: 0.3 }}></i>
                                <p className="mb-0">No quotations found</p>
                              </td>
                            </tr>
                          ) : (
                            quotations.map((item, index) => (
                              <tr key={item.id || index}>
                                <td>{item.id || index + 1}</td>
                                <td>{item.name || 'N/A'}</td>
                                <td>{item.email || 'N/A'}</td>
                                <td>{item.phoneno || item.phone || item.phone_number || 'N/A'}</td>
                                <td>{item.company || item.company_name || 'N/A'}</td>
                                <td>{item.service || item.service_type || 'N/A'}</td>
                                {/* <td>{item.subject || 'N/A'}</td> */}
                                <td>{item.message ? (item.message.length > 50 ? item.message.substring(0, 50) + '...' : item.message) : 'N/A'}</td>
                                {/* <td>{item.submitted_at || item.date || item.created_at || 'N/A'}</td> */}
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}

              {activeSection === 'lauratek-b2b' && (
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3>Lauratek B2B Inquiries</h3>
                    <button 
                      className="btn btn-sm btn-outline-primary"
                      onClick={fetchLauratekB2B}
                      disabled={lauratekB2BLoading}
                    >
                      <i className="fas fa-sync-alt me-2"></i>
                      {lauratekB2BLoading ? 'Refreshing...' : 'Refresh'}
                    </button>
                  </div>
                  
                  {lauratekB2BLoading ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-3">Loading B2B inquiries...</p>
                    </div>
                  ) : lauratekB2BError ? (
                    <div className="alert alert-danger">
                      <i className="fas fa-exclamation-triangle me-2"></i>
                      {lauratekB2BError}
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped table-hover">
                        <thead className="table-dark">
                          <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Business Name</th>
                            <th>Location</th>
                            <th>Industry Type</th>
                            
                          </tr>
                        </thead>
                        <tbody>
                          {lauratekB2B.length === 0 ? (
                            <tr>
                              <td colSpan="8" className="text-center text-muted py-4">
                                <i className="fas fa-inbox fa-2x mb-2" style={{ opacity: 0.3 }}></i>
                                <p className="mb-0">No B2B inquiries found</p>
                              </td>
                            </tr>
                          ) : (
                            lauratekB2B.map((item, index) => (
                              <tr key={item.id || index}>
                                <td>{item.id || index + 1}</td>
                                <td>{item.name || 'N/A'}</td>
                                <td>{item.email || 'N/A'}</td>
                                <td>{item.phoneno || item.phone || 'N/A'}</td>
                                <td>{item.name_of_business || item.business_name || 'N/A'}</td>
                                <td>{item.location || 'N/A'}</td>
                                <td>{item.industry_type || 'N/A'}</td>
                               
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}

              {activeSection === 'lauratek-b2c' && (
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3>Lauratek B2C Inquiries</h3>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={fetchLauratekB2C}
                      disabled={lauratekB2CLoading}
                    >
                      <i className="fas fa-sync-alt me-2"></i>
                      {lauratekB2CLoading ? 'Refreshing...' : 'Refresh'}
                    </button>
                  </div>

                  {lauratekB2CLoading ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-3">Loading B2C inquiries...</p>
                    </div>
                  ) : lauratekB2CError ? (
                    <div className="alert alert-danger">
                      <i className="fas fa-exclamation-triangle me-2"></i>
                      {lauratekB2CError}
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped table-hover">
                        <thead className="table-dark">
                          <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Course Type</th>
                            <th>Location</th>
                            <th>Education Status</th>
                            <th>Interest</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lauratekB2C.length === 0 ? (
                            <tr>
                              <td colSpan="8" className="text-center text-muted py-4">
                                <i className="fas fa-inbox fa-2x mb-2" style={{ opacity: 0.3 }}></i>
                                <p className="mb-0">No B2C inquiries found</p>
                              </td>
                            </tr>
                          ) : (
                            lauratekB2C.map((item, index) => (
                              <tr key={item.id || index}>
                                <td>{item.id || index + 1}</td>
                                <td>{item.name || 'N/A'}</td>
                                <td>{item.email || 'N/A'}</td>
                                <td>{item.phoneno || item.phone || 'N/A'}</td>
                                <td>{item.course_type || 'N/A'}</td>
                                <td>{item.location || 'N/A'}</td>
                                <td>{item.edu_status || 'N/A'}</td>
                                <td>{item.interest ||'N/A'}</td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}

              {activeSection === 'hrms' && (
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3>HRMS Inquiries</h3>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={fetchHrms}
                      disabled={hrmsLoading}
                    >
                      <i className="fas fa-sync-alt me-2"></i>
                      {hrmsLoading ? 'Refreshing...' : 'Refresh'}
                    </button>
                  </div>

                  {hrmsLoading ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-3">Loading HRMS inquiries...</p>
                    </div>
                  ) : hrmsError ? (
                    <div className="alert alert-danger">
                      <i className="fas fa-exclamation-triangle me-2"></i>
                      {hrmsError}
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped table-hover">
                        <thead className="table-dark">
                          <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Location</th>
                            <th>No. of Employees</th>
                            <th>No. of Branches</th>
                            <th>Product Taking Time</th>
                            <th>Submitted At</th>
                          </tr>
                        </thead>
                        <tbody>
                          {hrms.length === 0 ? (
                            <tr>
                              <td colSpan="9" className="text-center text-muted py-4">
                                <i className="fas fa-inbox fa-2x mb-2" style={{ opacity: 0.3 }}></i>
                                <p className="mb-0">No HRMS inquiries found</p>
                              </td>
                            </tr>
                          ) : (
                            hrms.map((item, index) => (
                              <tr key={item.id || index}>
                                <td>{item.id || index + 1}</td>
                                <td>{item.name || 'N/A'}</td>
                                <td>{item.email || 'N/A'}</td>
                                <td>{item.phoneno || item.phone || 'N/A'}</td>
                                <td>{item.location || 'N/A'}</td>
                                <td>{item.no_of_employees || 'N/A'}</td>
                                <td>{item.no_of_branches || 'N/A'}</td>
                                <td>{item.product_taking_time || 'N/A'}</td>
                                <td>{item.submitted_at || item.date || item.created_at || 'N/A'}</td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}

              {activeSection === 'lens-light' && (
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3>Lens & Light media Inquiries</h3>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={fetchLensLight}
                      disabled={lensLightLoading}
                    >
                      <i className="fas fa-sync-alt me-2"></i>
                      {lensLightLoading ? 'Refreshing...' : 'Refresh'}
                    </button>
                  </div>

                  {lensLightError && (
                    <div className="alert alert-danger mb-4">
                      <i className="fas fa-exclamation-triangle me-2"></i>
                      {lensLightError}
                    </div>
                  )}

                  <div className="table-responsive">
                    <table className="table table-bordered table-striped table-hover">
                      <thead className="table-dark">
                        <tr>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Website</th>
                          <th>Category</th>
                          <th>Note</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lensLightLoading ? (
                          <tr>
                            <td colSpan="6" className="text-center py-4">
                              <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                              <p className="mb-0 mt-2">Loading Lens & Light inquiries...</p>
                            </td>
                          </tr>
                        ) : lensLight.length === 0 ? (
                          <tr>
                            <td colSpan="6" className="text-center text-muted py-4">
                              <i className="fas fa-inbox fa-2x mb-2" style={{ opacity: 0.3 }}></i>
                              <p className="mb-0">No Lens & Light media inquiries found</p>
                            </td>
                          </tr>
                        ) : (
                          lensLight.map((item, index) => (
                            <tr key={item.id || index}>
                              <td>{item.name || 'N/A'}</td>
                              <td>{item.email || 'N/A'}</td>
                              <td>{item.phone || 'N/A'}</td>
                              <td>{item.website || 'N/A'}</td>
                              <td>{item.category || 'N/A'}</td>
                              <td>{item.note || 'N/A'}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {activeSection === 'hms' && (
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3>HMS Inquiries</h3>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={fetchHms}
                      disabled={hmsLoading}
                    >
                      <i className="fas fa-sync-alt me-2"></i>
                      {hmsLoading ? 'Refreshing...' : 'Refresh'}
                    </button>
                  </div>

                  {hmsLoading ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-3">Loading HMS inquiries...</p>
                    </div>
                  ) : hmsError ? (
                    <div className="alert alert-danger">
                      <i className="fas fa-exclamation-triangle me-2"></i>
                      {hmsError}
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped table-hover">
                        <thead className="table-dark">
                          <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Purpose</th>
                            <th>Branch Type</th>
                            <th>Type Of</th>
                            <th>Services</th>
                            <th>No. of Beds</th>
                            <th>Total Logins</th>
                            <th>Product Taking Time</th>
                            <th>Heard From</th>
                            <th>Submitted At</th>
                          </tr>
                        </thead>
                        <tbody>
                          {hms.length === 0 ? (
                            <tr>
                              <td colSpan="13" className="text-center text-muted py-4">
                                <i className="fas fa-inbox fa-2x mb-2" style={{ opacity: 0.3 }}></i>
                                <p className="mb-0">No HMS inquiries found</p>
                              </td>
                            </tr>
                          ) : (
                            hms.map((item, index) => (
                              <tr key={item.id || index}>
                                <td>{item.id || index + 1}</td>
                                <td>{item.name || 'N/A'}</td>
                                <td>{item.email || 'N/A'}</td>
                                <td>{item.phoneno || item.phone || 'N/A'}</td>
                                <td>{item.purpose || 'N/A'}</td>
                                <td>{item.branch_type || 'N/A'}</td>
                                <td>{item.type_of || 'N/A'}</td>
                                <td>{item.services || 'N/A'}</td>
                                <td>{item.no_of_beds || 'N/A'}</td>
                                <td>{item.total_logins || 'N/A'}</td>
                                <td>{item.product_taking_time || 'N/A'}</td>
                                <td>{item.heard_from || 'N/A'}</td>
                                <td>{item.submitted_at || item.date || item.created_at || 'N/A'}</td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}

              {activeSection === 'sams' && (
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3>SAMS Inquiries</h3>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={fetchSams}
                      disabled={samsLoading}
                    >
                      <i className="fas fa-sync-alt me-2"></i>
                      {samsLoading ? 'Refreshing...' : 'Refresh'}
                    </button>
                  </div>

                  {samsLoading ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-3">Loading SAMS inquiries...</p>
                    </div>
                  ) : samsError ? (
                    <div className="alert alert-danger">
                      <i className="fas fa-exclamation-triangle me-2"></i>
                      {samsError}
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped table-hover">
                        <thead className="table-dark">
                          <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Location</th>
                            <th>No. of Branches</th>
                            <th>Industry Type</th>
                            <th>No. of People</th>
                            <th>Subject</th>
                            <th>Message</th>
                            <th>Submitted At</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sams.length === 0 ? (
                            <tr>
                              <td colSpan="11" className="text-center text-muted py-4">
                                <i className="fas fa-inbox fa-2x mb-2" style={{ opacity: 0.3 }}></i>
                                <p className="mb-0">No SAMS inquiries found</p>
                              </td>
                            </tr>
                          ) : (
                            sams.map((item, index) => (
                              <tr key={item.id || index}>
                                <td>{item.id || index + 1}</td>
                                <td>{item.name || 'N/A'}</td>
                                <td>{item.email || 'N/A'}</td>
                                <td>{item.phoneno || item.phone || 'N/A'}</td>
                                <td>{item.location || 'N/A'}</td>
                                <td>{item.no_of_branches || 'N/A'}</td>
                                <td>{item.industry_type || 'N/A'}</td>
                                <td>{item.no_of_people || 'N/A'}</td>
                                <td>{item.subject || 'N/A'}</td>
                                <td>{item.message || 'N/A'}</td>
                                <td>{item.submitted_at || item.date || item.created_at || 'N/A'}</td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}

              {activeSection === 'onestepmedi' && (
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3>Onestepmedi Inquiries</h3>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={fetchOnestepmedi}
                      disabled={onestepmediLoading}
                    >
                      <i className="fas fa-sync-alt me-2"></i>
                      {onestepmediLoading ? 'Refreshing...' : 'Refresh'}
                    </button>
                  </div>

                  {onestepmediLoading ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-3">Loading Onestepmedi inquiries...</p>
                    </div>
                  ) : onestepmediError ? (
                    <div className="alert alert-danger">
                      <i className="fas fa-exclamation-triangle me-2"></i>
                      {onestepmediError}
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped table-hover">
                        <thead className="table-dark">
                          <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Location</th>
                            <th>Promotion Type</th>
                            <th>Submitted At</th>
                          </tr>
                        </thead>
                        <tbody>
                          {onestepmedi.length === 0 ? (
                            <tr>
                              <td colSpan="7" className="text-center text-muted py-4">
                                <i className="fas fa-inbox fa-2x mb-2" style={{ opacity: 0.3 }}></i>
                                <p className="mb-0">No Onestepmedi inquiries found</p>
                  </td>
                </tr>
                          ) : (
                            onestepmedi.map((item, index) => (
                              <tr key={item.id || index}>
                                <td>{item.id || index + 1}</td>
                                <td>{item.name || 'N/A'}</td>
                                <td>{item.email || 'N/A'}</td>
                                <td>{item.phoneno || item.phone || 'N/A'}</td>
                                <td>{item.location || 'N/A'}</td>
                                <td>{item.promotion_type || 'N/A'}</td>
                                <td>{item.submitted_at || item.date || item.created_at || 'N/A'}</td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}

              {activeSection === 'careers' && (
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3>Career Applications</h3>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={fetchCareers}
                      disabled={careersLoading}
                    >
                      <i className="fas fa-sync-alt me-2"></i>
                      {careersLoading ? 'Refreshing...' : 'Refresh'}
                    </button>
                  </div>

                  {careersLoading ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-3">Loading career applications...</p>
                    </div>
                  ) : careersError ? (
                    <div className="alert alert-danger">
                      <i className="fas fa-exclamation-triangle me-2"></i>
                      {careersError}
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped table-hover">
                        <thead className="table-dark">
                          <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Location</th>
                            <th>Position Applied</th>
                            <th>Message</th>
                            <th>Resume</th>
                            <th>Submitted At</th>
                          </tr>
                        </thead>
                        <tbody>
                          {careers.length === 0 ? (
                            <tr>
                              <td colSpan="9" className="text-center text-muted py-4">
                                <i className="fas fa-inbox fa-2x mb-2" style={{ opacity: 0.3 }}></i>
                                <p className="mb-0">No career applications found</p>
                  </td>
                </tr>
              ) : (
                            careers.map((item, index) => (
                              <tr key={item.id || index}>
                                <td>{item.id || index + 1}</td>
                    <td>{item.name || 'N/A'}</td>
                    <td>{item.email || 'N/A'}</td>
                                <td>{item.phoneno || item.phone || 'N/A'}</td>
                                <td>{item.location || 'N/A'}</td>
                                <td>{item.position_applied || item.position || 'N/A'}</td>
                                <td>{item.message || 'N/A'}</td>
                                <td>
                                  {item.resume ? (
                                    <a href={item.resume} target="_blank" rel="noreferrer" className="text-primary">
                                      <i className="fas fa-file-pdf me-1"></i>View
                                    </a>
                                  ) : 'N/A'}
                                </td>
                                <td>{item.submitted_at || item.date || item.created_at || 'N/A'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DevOpsInquiries;